import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'swb-novelties',
  templateUrl: './novelties.component.html'
})
export class NoveltiesComponent implements OnInit {

  ngOnInit() {
  }

}
